import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslocoPipe } from "@jsverse/transloco";
import { interval, map, startWith } from "rxjs";
import { LorenAuthenticationService } from "../../../../../../services/loren-authentication-service/loren-authentication.service";
import { LorenDateUtilsService } from "../../../../../../services/loren-date-utils-service/loren-date-utils.service";

@Component({
  selector: "loren-impersonation-banner",
  imports: [CommonModule, TranslocoPipe],
  templateUrl: "./loren-impersonation-banner.component.html",
  styleUrl: "./loren-impersonation-banner.component.scss",
})
export class LorenImpersonationBannerComponent {
  private authService = inject(LorenAuthenticationService);

  readonly impersonation = this.authService.getImpersonation();

  // Recompute minute granularity every 30s; ends the session on expiry.
  readonly minutesLeft$ = interval(30_000).pipe(
    startWith(0),
    map(() => this.minutesLeft())
  );

  // Ends impersonation and reverts to the stashed admin session. Falls back
  // to a full logout if there's nothing to restore.
  exit(): void {
    if (!this.authService.stopImpersonation()) {
      this.authService.logout();
    }
    window.location.href = "/";
  }

  private minutesLeft(): number {
    if (!this.impersonation) {
      return 0;
    }

    // expiresAt is rehydrated from localStorage JSON, so it's a plain string
    // here — wrap it back into a Dayjs before diffing.
    const diff = LorenDateUtilsService.getMomentFromDate(
      this.impersonation.expiresAt
    ).diff(LorenDateUtilsService.getMomentNow(), "minute");

    if (diff <= 0) {
      this.exit();
    }

    return Math.max(diff, 0);
  }
}
